import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Form, Input, Button, Card } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../../context/AuthContext';
import { rutaPostAuth, rutaRegistro } from '../../utils/rutasAcceso';
import { useAvisarAltoAlPadre } from '../../hooks/useAvisarAltoAlPadre';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Se abre DENTRO del iframe del micrositio (RematePage navega por SPA, sin
  // salir del embed). El por que y su dependencia con el CSS estan en el hook.
  useAvisarAltoAlPadre();

  // Slug del remate del que viene la persona (llega desde el micrositio o
  // arrastrado desde /registro cuando el email ya existía).
  const eventoSlug = searchParams.get('evento');

  const onFinish = async (values) => {
    setLoading(true);
    let result;
    try {
      result = await login(values.email, values.password);
    } finally {
      setLoading(false);
    }

    if (result?.success) {
      const u = result.user;
      // El comprador que viene de un micrositio va a la lista de remates con
      // ese remate resaltado. A diferencia del alta acá NO se crea ninguna
      // solicitud sola: en un login la intención es ambigua (el navegador puede
      // autocompletar una URL vieja con el slug de otra cabaña). Para el resto
      // de los roles decide `rutaPanel`, que es la única fuente de esa lógica.
      navigate(rutaPostAuth(u, eventoSlug));
    }
  };

  return (
    <div className="auth-container">
      <Card className="auth-card" variant="borderless">
        <div className="auth-title">
          <h1 className="puja-wordmark">PUJA</h1>
          <p>Gestión de Cabañas</p>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
          requiredMark={false}
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Ingresá tu email' },
              { type: 'email', message: 'Email inválido' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Email"
              autoComplete="email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Ingresá tu contraseña' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Contraseña"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item style={{ marginTop: 28, marginBottom: 16 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 44, fontWeight: 700, letterSpacing: '0.05em' }}
            >
              Ingresar
            </Button>
          </Form.Item>

          <div style={{
            textAlign: 'center',
            fontSize: 13,
            color: 'var(--puja-graphite)',
            marginTop: 8,
          }}>
            {/* El slug viaja también por acá: si se pierde en el cross-link, la
                persona llega a /registro sin evento, no se le crea la solicitud
                y aterriza lejos del remate que estaba mirando. */}
            ¿Todavía no tenés cuenta?{' '}
            <Link
              to={rutaRegistro(eventoSlug)}
              style={{ fontWeight: 600 }}
            >
              Registrate
            </Link>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
